import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "sna-archive",
      path: "sna-archive",
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "sna_archive",
        title: i18n.global.t("SNA Archive"),
      },
      component: () => import("pages/employee/SNAArchive"),
    },
  ],

  dialogs: [
    {
      name: "sna-archive-add",
      path: "/sna-archive/add",
      component: () => import("../../../dialogs/employee/SNAArchiveAdd"),
    },
  ],
};
